import React from 'react';

const SuccessMessage = ({ message, onClose }) => {
  return (
    <div className="alert alert-success alert-dismissible">
      <strong>Success:</strong> {message}
      {onClose && (
        <button type="button" className="btn-close" onClick={onClose}>
          ×
        </button>
      )}
    </div>
  );
};

export default SuccessMessage;
